import { Link } from "react-router-dom";

export function TeamBadge({
  name,
  short,
  size = "md",
}: {
  name: string;
  short?: string;
  size?: "sm" | "md" | "lg";
}) {
  const sizes = {
    sm: "h-9 w-9 text-xs",
    md: "h-12 w-12 text-sm",
    lg: "h-16 w-16 text-lg",
  };
  const label = short ?? name.slice(0, 2);
  return (
    <span
      title={name}
      className={`flex shrink-0 items-center justify-center rounded-full bg-primary-500 font-extrabold text-background-50 ${sizes[size]}`}
    >
      {label.slice(0, 4)}
    </span>
  );
}

export function FormDots({ form }: { form: string[] }) {
  const map: Record<string, string> = {
    W: "bg-primary-500 text-background-50",
    D: "bg-secondary-300 text-secondary-900",
    L: "bg-accent-500 text-background-50",
  };
  return (
    <div className="flex items-center gap-1.5">
      {form.map((f, i) => (
        <span
          key={i}
          className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold ${map[f] ?? "bg-background-300 text-foreground-700"}`}
        >
          {f}
        </span>
      ))}
    </div>
  );
}

export function Breadcrumb({ items }: { items: { label: string; to?: string }[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-800">{item.label}</span>
          )}
          {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
        </span>
      ))}
    </nav>
  );
}

export function SectionHeading({
  title,
  subtitle,
  to,
  toLabel,
  icon,
}: {
  title: string;
  subtitle?: string;
  to?: string;
  toLabel?: string;
  icon?: string;
}) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-start gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-700">
            <i className={icon}></i>
          </span>
        )}
        <div>
          <h2 className="text-xl font-extrabold tracking-tight text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {to && toLabel && (
        <Link
          to={to}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-800"
        >
          {toLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}